



















































import { Component, Mixins } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import BaseAsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";
import DataTable from "@/components/DataTable/DataTable.vue";

import RequestState from "@/utils/mixins/RequestState";

import { IVuexState } from "@/models/interfaces/store";
import { IClass } from "@/models/interfaces/classes";
import { IStudent } from "@/models/interfaces/students";
import { AssignSubGroupDTO } from "@/models/interfaces/users";
import { AxiosError } from "axios";

@Component({
  components: {
    BaseAsyncButton,
    BaseDropdown,
    InputRow,
    BaseButton,
    BasePopup,

    AppHeaderBackWithTitle,
    AppHeader,
    AppContent,
    DataTable
  }
})
export default class DataSelection extends Mixins(RequestState) {
  @State("classes", { namespace: "classes" })
  public classes!: IVuexState<IClass[]>;

  @State("students", { namespace: "classes" })
  public users!: IVuexState<IStudent[]>;

  @Action("classes/fetchStudentsInClass")
  public fetchStudentsInClass!: (classId: string) => Promise<IStudent[]>;

  @Action("users/assignSubGroupToUser")
  public assignSubGroupToUser!: (dto: AssignSubGroupDTO) => Promise<unknown>;

  public isSaving = false;
  public isPopupShown = false;

  public popupMessage = "";

  public changedUsers: Array<{
    userId: string;
    subGroupId: string | null;
  }> = [];

  public get subGroups() {
    const group = this.classes.data?.find(
      item => item.classId === this.$route.params.groupId
    );

    return (group?.subGroups ?? []).map(({ name, subGroupId }) => ({
      value: subGroupId,
      label: name
    }));
  }

  public get tableColumns() {
    const baseColumns = [
      {
        value: "firstname",
        label: this.$t("views.subGroups.table.firstName")
      },
      {
        value: "lastname",
        label: this.$t("views.subGroups.table.lastName")
      },
      {
        value: "username",
        label: this.$t("views.subGroups.table.username")
      }
    ];

    return this.subGroups.length
      ? [
          ...baseColumns,
          {
            value: "subGroup",
            label: this.$t("views.subGroups.table.subGroup"),
            custom: true,
            name: "subGroup"
          }
        ]
      : baseColumns;
  }

  public async handleSave() {
    this.isSaving = true;

    try {
      const promises = this.changedUsers.map(user =>
        this.assignSubGroupToUser({
          userId: user.userId,
          subGroupId: user.subGroupId
        })
      );

      await Promise.all(promises);
      this.popupMessage = this.$t("views.subGroups.successAssign").toString();
      this.isPopupShown = true;
    } catch (e) {
      const error = e as AxiosError;

      if (error.response?.status !== 403) {
        this.popupMessage = this.$t("views.subGroups.errors.assign").toString();
        this.isPopupShown = true;
      }
    }

    this.isSaving = false;
  }

  public addSubGroupAssignee(subGroupId: string | null = null, userId: string) {
    const addedUser = this.changedUsers.find(item => item.userId === userId);

    if (addedUser) {
      this.changedUsers = this.changedUsers.map(item =>
        item.userId === userId ? { userId: item.userId, subGroupId } : item
      );
      return;
    }

    this.changedUsers.push({
      subGroupId,
      userId
    });
  }

  public mounted() {
    this.fetchStudentsInClass(this.$route.params.groupId);
  }
}
